const { sameParagraphStyleInTextBodies } = require('../utils');

exports.computeAlignFromTextBodies = (textBodies, textSelection) => {
    const align = sameParagraphStyleInTextBodies(textBodies, 'align', '', { skipUndefined: false, textSelection });
    return align;
};
